import { categories } from '@/mocks/categories';

export default function Hero() {
  const scrollToCategories = () => {
    document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex flex-col">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20editorial%20display%20with%20premium%20leather%20sneakers%2C%20woven%20textile%20accessories%20and%20designer%20sunglasses%20elegantly%20scattered%20on%20warm%20sandstone%20surface%2C%20golden%20afternoon%20sunlight%20casting%20long%20soft%20shadows%2C%20Mediterranean%20terracotta%20and%20sage%20color%20palette%2C%20lifestyle%20product%20photography%20with%20organic%20botanical%20elements%2C%20high-end%20catalog%20composition%2C%20gentle%20film%20grain%20texture&width=1600&height=1000&seq=hero-v2-main-hub-jul&orientation=landscape"
          alt="Superbuy Spreadsheet fashion and sneaker collection showcase"
          title="Superbuy Spreadsheet 2026 Product Resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center flex-1 w-full px-6 md:px-10 pt-24 md:pt-32">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16 max-w-[1400px] mx-auto w-full">
          {/* Left side */}
          <div className="lg:w-[55%] text-white">
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.05] tracking-tight">
              Superbuy<br />
              Spreadsheet<br />
              <span className="text-background-50/90">2026 Hub</span>
            </h1>
            <p className="mt-6 text-lg md:text-xl text-background-50/80 max-w-xl leading-relaxed">
              The ultimate resource hub for smarter online shopping. Find organized product collections, updated spreadsheets, QC information, and expert tips.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-50/40 text-background-50 font-semibold text-sm rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line text-base w-4 h-4 flex items-center justify-center"></i>
                Superbuy Sheet
              </a>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-4 text-xs text-background-50/60">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center"></i> Updated Resources
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center"></i> Beginner Friendly
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center"></i> QC Information
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center"></i> Global Support
              </span>
            </div>
          </div>

          {/* Right side */}
          <div className="lg:w-[45%] flex flex-col items-start lg:items-end justify-end pb-10 lg:pt-32">
            <p className="text-background-50/70 text-base max-w-sm lg:text-right leading-relaxed">
              Browse our curated product categories to discover the best Superbuy finds across shoes, apparel, accessories and more.
            </p>
            <button
              onClick={scrollToCategories}
              className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 border border-background-50/50 text-background-50 text-sm rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              View Categories
              <i className="ri-arrow-down-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Bottom decorative image strip */}
      <div className="relative z-10 w-full mt-auto">
        <div className="w-full h-32 md:h-48 overflow-hidden rounded-t-[24px]">
          <img
            src="https://readdy.ai/api/search-image?query=Horizontal%20product%20photography%20banner%20with%20luxury%20sneakers%2C%20woven%20basket%20bags%2C%20tortoiseshell%20sunglasses%20and%20linen%20scarves%20arranged%20on%20warm%20clay%20textured%20surface%2C%20morning%20soft%20light%2C%20artisanal%20Mediterranean%20aesthetic%2C%20muted%20earth%20tones%20with%20olive%20and%20rust%20accents%2C%20editorial%20catalog%20layout&width=1440&height=300&seq=hero-v2-bottom-panorama&orientation=landscape"
            alt="Curated Superbuy fashion and accessories collection"
            title="Superbuy Spreadsheet curated collections"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}